<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      title="Sikkerhetsinnstruks"
      subtitle="Du må bekrefte for å komme inn på byggeplass"
      dialogIcon="mdi-account-hard-hat"
      @close="$emit('close')"
    >
      <template v-slot>
        <span v-if="!isPsiMissing">
          <span v-if="noHMScard">
            Du har ikke lagt til HMS-kort. For å komme inn på byggelass må du
            legge til HMS-kort! Du legger til HMS-kort på "Min profil".

            <v-btn
              class="mt-3"
              color="primary"
              block
              depressed
              :to="{ name: 'Profile' }"
            >
              Gå til Min Profil
            </v-btn>
          </span>
          <span v-else>
            <small>Klikk lenken</small>
            <v-btn color="cardBtnBadge" block depressed @click="openLink"
              >Personlig sikkerhetsinnstruks
              <v-icon small right>mdi-open-in-new</v-icon>
            </v-btn>
            <v-card-text class="px-0">
              Jeg bekrefter at jeg har lest gjennom personlig
              sikkerhetsinnstruks og godkjenner innholdet.
            </v-card-text>
            <v-card-text class="px-0 mb-12">
              Du må åpne lenken for å bekrefte.
            </v-card-text>

            <v-btn
              block
              color="primary"
              :disabled="!linkOpened"
              depressed
              @click="$emit('confirm')"
            >
              Bekreft
            </v-btn>
          </span>
        </span>
        <span v-else>
          <v-alert text type="error">
            Det er ikke mulig å bekrefte PSI for øyeblikket! Kontakt HMS
            ansvarlig! Mangler PSI dokument
          </v-alert>
        </span>
      </template>
    </BaseDialog>
    <PDFDialog
      v-model="openPDF"
      :blob="blob"
      :fileName="fileName"
      @pdfOpened="linkOpened = true"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import PDFDialog from "@/components/shared/dialog/PDFDialog.vue";

import projectApi from "@/api/projectApi";
import { getFileNameFromHeader } from "@/helpers/saveFile";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    projectId: {
      type: [Number, String],
      required: true,
    },
    isPsiMissing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkOpened: false,
      blob: null,
      fileName: null,
      openPDF: false,
    };
  },

  methods: {
    openLink() {
      if (this.projectId) {
        projectApi.getPsi(this.projectId).then((response) => {
          this.fileName = getFileNameFromHeader(response.headers);
          this.blob = response.data;
          this.openPDF = true;
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      noHMScard: "shared/noHMScard",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
    PDFDialog,
  },
});
</script>
